module.exports = __webpack_public_path__ + "img/micropscope.01aa8fd4.png";